export const initialState = {
  actionProcessing: false,
  points: {
    myPoints: 0,
    cashiersList: [],
  }
};
